import React from 'react';

import cn from 'clsx';

import styles from './calendar-date.module.scss';

export interface ICalendarDateProps {
  inactive?: boolean;
  announced?: boolean;
  className?: string;
  dataTestId?: string;
}

export const Day: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => <div className={cn(styles.day, className)}>{children}</div>;

interface IMonthProps {
  children: string;
  className?: string;
  variant?: 'default' | 'adaptive';
}

const MONTH_VARIANT = 'default';

export const Month: React.FC<React.PropsWithChildren<IMonthProps>> = ({
  children,
  variant = MONTH_VARIANT,
  className,
}) => {
  let content: React.ReactElement | null = null;

  if (variant === MONTH_VARIANT) {
    content = <span className={styles.monthDefault}>{children}</span>;
  } else {
    const shortMonth = children.slice(0, 3);
    content = (
      <>
        <span className={styles.monthFull}>{children}</span>
        <span className={styles.monthShort}>{shortMonth}</span>
      </>
    );
  }

  return <div className={cn(styles.month, className)}>{content}</div>;
};

export const Year: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => <div className={styles.year}>{children}</div>;

export const CalendarDate: React.FC<
  React.PropsWithChildren<ICalendarDateProps>
> = ({
  inactive = false,
  announced = true,
  className,
  children,
  dataTestId,
}) => {
  return (
    <div
      data-testid={dataTestId}
      className={cn(
        styles.calendar,
        { [styles.calendarInactive]: inactive },
        className
      )}
    >
      {announced ? (
        children
      ) : (
        <span className={styles.futureAnnounce}>TBA</span>
      )}
    </div>
  );
};
